import { render } from "./StationPackNoCenter.vue?vue&type=template&id=665f8416&scoped=true"
import script from "./StationPackNoCenter.vue?vue&type=script&lang=js"
export * from "./StationPackNoCenter.vue?vue&type=script&lang=js"

import "./StationPackNoCenter.vue?vue&type=style&index=0&id=665f8416&scoped=true&lang=css"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665f8416"]])

export default __exports__